import http from "../../http-common";

const get = (data) => http.post("/ProfileMenu/FilterProfileMenu", data);

const create = (data) => http.post("/ProfileMenu/InsertProfileMenu", data);

const remove = (data) =>
  http.request({
    url: "/ProfileMenu/DeleteProfileMenu",
    method: "delete",
    data: data,
  });

export default { get, create, remove };
